import styled from 'styled-components';
import { getDemoData } from 'utils/helpers';
import { DetailsItem } from 'elements/DetailsItem';
import { formatOptionalBooleanYesNo } from 'utils/formatBooleanYesNo';
import { stageLabelForDisplay } from 'utils/residentTerminology';

export const DetailCard = ({ application, isDemo }) => {
  return (
    <DetailCardContainer>
      <DetailsItem
        label="Account Name"
        value={!isDemo ? application.tenant_1_name : getDemoData('tenant-name')}
      />
      <DetailsItem
        label="Stage"
        value={application.stage ? stageLabelForDisplay(application.stage) : 'No Data'}
      />
      <DetailsItem
        label="Months Remaining"
        value={
          application.months_remaining ? parseInt(application.months_remaining, 10) : 'No Data'
        }
      />
      <DetailsItem
        label="Active Lease"
        value={formatOptionalBooleanYesNo(application.active_lease)}
      />
      <DetailsItem
        label="Application Type"
        value={application.app_type ? application.app_type : 'No Data'}
      />
      <DetailsItem
        label="Operator Name"
        value={!isDemo ? application.lanlord_account_name : getDemoData('landlord-name')}
      />
      <DetailsItem
        label="Created Date"
        value={
          application.sf_createdDate
            ? new Date(application.sf_createdDate).toISOString().slice(0, 10)
            : 'No Data'
        }
        isLastItem
      />
    </DetailCardContainer>
  );
};

const DetailCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 2px;
  padding: 10px;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  background-color: rgba(248, 244, 249, 0.48);

  @media screen and (max-width: ${(props) => props.theme.lg}) {
    justify-content: start;
    gap: 10px;
    & > div {
      border: none;
      width: 30%;
      text-align: left;
      & > div {
        margin: 0;
      }
    }
  }

  @media screen and (max-width: ${(props) => props.theme.sm}) {
    & > div {
      width: 100%;
    }
  }
`;
